class CollectionSwatch {
  constructor(productId) {
    this.productId = productId;
    this.variantMap = {};
    this.variableImageMapping = {};
    this.imageSize = '250x'; // Smaller image size for faster loading
    
    this.init();
  }

  init() {
    this.initFirstAvailableSwatch();
    this.initSwatchClickHandlers();
    this.initVariantMaps();
  }

  initFirstAvailableSwatch() {
    $(`.swatch-element-${this.productId}`).each(function() {
      if (!$(this).hasClass('soldout')) {
        $(this).find('input').click();
        return false;
      }
    });
  }

  initSwatchClickHandlers() {
    $(`.swatch-collection-${this.productId}`).click((e) => {
      const swatch = $(e.currentTarget);
      const varId = swatch.data('var_id');
      const currVal = swatch.find('input').val();
      const imageContainer = $(`#c${this.productId} img`);
      const productLink = $(`#c${this.productId} a`);

      // Create and preload new image
      const newImage = new Image();
      newImage.onload = () => {
        if (this.variantMap[currVal]) {
          imageContainer.attr('src', newImage.src);
          productLink.attr('href', `${productUrl}?variant=${this.variantMap[currVal][0].id}`);
        } else if (currVal in this.variableImageMapping && this.variableImageMapping[currVal][0]) {
          imageContainer.attr('src', newImage.src);
        }
      };

      // Set source after defining onload
      if (this.variantMap[currVal]) {
        newImage.src = this.variantMap[currVal][0].image.replace('1600x', this.imageSize);
      } else if (currVal in this.variableImageMapping && this.variableImageMapping[currVal][0]) {
        newImage.src = this.variableImageMapping[currVal][0].replace('480x', this.imageSize);
      }
    });

    $(`input[name=option-${this.productId}-0]`).change((e) => {
      this.handleVariantChange($(e.currentTarget).val());
    });
  }

  handleVariantChange(currVal) {
    // Update non-color swatch states
    $(`.swatch-element-${this.productId}:not(.color)`).each(function() {
      $(this).find('input').attr('disabled', false);
      $(this).find('.crossed-out').css('display', 'none');
      $(this).removeClass('soldout').addClass('available');
    });

    // Update image
    const imageContainer = $(`#c${this.productId} img`);
    const productLink = $(`#c${this.productId} a`);
    
    if (this.variantMap[currVal]) {
      const newImage = new Image();
      newImage.onload = () => {
        imageContainer.attr('src', newImage.src);
        productLink.attr('href', `${productUrl}?variant=${this.variantMap[currVal][0].id}`);
      };
      newImage.src = this.variantMap[currVal][0].image.replace('1600x', this.imageSize);
    }

    // Update soldout states
    if (this.variantMap[currVal]) {
      this.variantMap[currVal].forEach(variant => {
        if (!variant.stock) {
          const element = $(`.swatch-element-${this.productId}[data-value="${variant.name}"]`);
          element.find('input').attr('disabled', true);
          element.find('.crossed-out').css('display', 'block');
          element.addClass('soldout').removeClass('available');
        }
      });
    }
  }

  initVariantMaps() {
    // Initialize variant maps from the global variables
    this.variantMap = window[`variant_map_${this.productId}`] || {};
    this.variableImageMapping = window[`variable_image_mapping_${this.productId}`] || {};
  }
}

// Initialize swatches when document is ready
$(document).ready(() => {
  // Find all swatch containers and initialize
  $('.swatch').each(function() {
    const productId = $(this).closest('[data-product-id]').data('product-id');
    if (productId) {
      new CollectionSwatch(productId);
    }
  });
}); 